import script from "./createPackage.vue?vue&type=script&setup=true&lang=js"
export * from "./createPackage.vue?vue&type=script&setup=true&lang=js"

import "./createPackage.vue?vue&type=style&index=0&id=4d2c3f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2c3f16"]])

export default __exports__